import { render } from "./extraLarge.vue?vue&type=template&id=cdb43770"
import script from "./extraLarge.vue?vue&type=script&lang=js"
export * from "./extraLarge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__